import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { StyledText } from '@selfserve/react-ui';

import {
  StyledLoader,
  StyledPriceContainer,
  StyledPricePair,
  Addon,
} from '../feature/summary';

export const StyledRemove = styled('span')`
  text-decoration: underline;
  cursor: pointer;
`;

export const StyledSpan = styled('span')`
  text-transform: capitalize;
`;

interface Props {
  addons: Array<Addon>;
  isLoading: boolean;
  isCheckout?: boolean;
  withLine?: boolean;
  handleRemoveAddon: ((key: string) => () => void) | undefined;
}

export const SummaryAddons = ({
  addons,
  isLoading,
  isCheckout,
  withLine,
  handleRemoveAddon,
}: Props) => {
  const { t } = useTranslation();

  const numberWithCommas = useCallback((price: number, quantity: number) => {
    const amount = price * quantity;
    return amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }, []);

  return (
    <>
      {addons.map(({ key, name, price, quantity, secondaryName }, i, arr) => (
        <StyledPriceContainer withLine={withLine && i === arr.length - 1} key={key}>
          <StyledPricePair>
            <StyledText as="div" className="summary-item-name" bold isSmall>
              {name}
            </StyledText>
            <StyledText as="div" bold isSmall>
              {isLoading ? (
                <StyledLoader />
              ) : (
                <span className="addon-price">
                  {`$${numberWithCommas(price as number, quantity as number)}`}
                </span>
              )}
            </StyledText>
          </StyledPricePair>
          <StyledPricePair secondary>
            <StyledText as="div" className="summary-item-description">
              <span className="addon-description">
                <StyledSpan>{secondaryName}</StyledSpan>
                {handleRemoveAddon && !isCheckout && (
                  <>
                    {'\xa0\xa0•\xa0\xa0'}
                    <StyledRemove
                      className="summary-item-description-remove"
                      onClick={handleRemoveAddon(key as string)}
                    >
                      {t('common.remove')}
                    </StyledRemove>
                  </>
                )}
              </span>
            </StyledText>
          </StyledPricePair>
        </StyledPriceContainer>
      ))}
    </>
  );
};
